import axiosInstance from "auth/FetchInterceptor";
import {
  PURCHASE_ORDER_SEARCH_GRID,
  PURCHASE_ORDER_DETAIL,
  PURCHASE_ORDER_CREATE,
  PURCHASE_ORDER_CREATE_FROM_REQUEST_ORDER,
  PURCHASE_ORDER_UPDATE,
  PURCHASE_ORDER_MARK_PURCHASING,
  PURCHASE_ORDER_PAYMENT_STATUS,
  PURCHASE_ORDER_CLOSE_SHORT,
  PURCHASE_ORDER_DELETE,
  PURCHASE_ORDER_RECALCULATE_PROGRESS,
  PURCHASE_ORDER_ATTACHMENT,
  PURCHASE_ORDER_PREVIEW_PRICES,
  PURCHASE_ORDER_CREATE_MULTIPLE_FROM_REQUEST_ORDER,
  PURCHASE_ORDER_PREVIEW_MULTIPLE_PRICES,
  EXPORT_EXCEL_PURCHASE_ORDER,
} from "constants/ApiConstant";
import { withCurrentStore, withCurrentStoreInQuery } from "utils/currentStore";

const PurchaseOrderService = {};

PurchaseOrderService.getPurchaseOrder = function (data) {
  return axiosInstance.post(
    PURCHASE_ORDER_SEARCH_GRID,
    withCurrentStoreInQuery(data),
  );
};

PurchaseOrderService.createPurchaseOrder = function (data) {
  return axiosInstance.post(PURCHASE_ORDER_CREATE, withCurrentStore(data));
};

PurchaseOrderService.createPurchaseOrderFromRequestOrder = function (data) {
  return axiosInstance.post(
    PURCHASE_ORDER_CREATE_FROM_REQUEST_ORDER,
    withCurrentStore(data),
  );
};

PurchaseOrderService.updatePurchaseOrder = function (data) {
  return axiosInstance.put(PURCHASE_ORDER_UPDATE, withCurrentStore(data));
};

PurchaseOrderService.previewPrices = function (data) {
  return axiosInstance.post(
    PURCHASE_ORDER_PREVIEW_PRICES,
    withCurrentStore(data),
  );
};

PurchaseOrderService.previewMultipleFromRequestOrders = function (data) {
  return axiosInstance.post(
    PURCHASE_ORDER_PREVIEW_MULTIPLE_PRICES,
    withCurrentStore(data),
  );
};

PurchaseOrderService.createMultipleFromRequestOrders = function (data) {
  return axiosInstance.post(
    PURCHASE_ORDER_CREATE_MULTIPLE_FROM_REQUEST_ORDER,
    withCurrentStore(data),
  );
};

PurchaseOrderService.exportExcel = function (params) {
  return axiosInstance.post(
    EXPORT_EXCEL_PURCHASE_ORDER,
    withCurrentStore(params),
    {
      responseType: "blob",
    },
  );
};

PurchaseOrderService.getPurchaseOrderDetail = function (id) {
  return axiosInstance.get(`${PURCHASE_ORDER_DETAIL}/${id}`);
};

PurchaseOrderService.markPurchasing = function (id) {
  return axiosInstance.put(`${PURCHASE_ORDER_MARK_PURCHASING}/${id}`);
};

PurchaseOrderService.updatePaymentStatus = function (data) {
  return axiosInstance.put(PURCHASE_ORDER_PAYMENT_STATUS, data);
};

PurchaseOrderService.closeShortPurchaseOrder = function (data) {
  return axiosInstance.put(PURCHASE_ORDER_CLOSE_SHORT, data);
};

PurchaseOrderService.delPurchaseOrder = function (id) {
  return axiosInstance.delete(`${PURCHASE_ORDER_DELETE}/${id}`, null);
};

PurchaseOrderService.recalculateProgress = function (id) {
  return axiosInstance.put(`${PURCHASE_ORDER_RECALCULATE_PROGRESS}/${id}`);
};

PurchaseOrderService.addAttachment = function (data) {
  return axiosInstance.post(PURCHASE_ORDER_ATTACHMENT, data);
};

PurchaseOrderService.delAttachment = function (id) {
  return axiosInstance.delete(`${PURCHASE_ORDER_ATTACHMENT}/${id}`, null);
};

export default PurchaseOrderService;
